<router-outlet></router-outlet>
<app-loader *ngIf="isLoading"></app-loader>